// extracted by mini-css-extract-plugin
export var text = "_42-0";